export const TYPE_ARTICLE = 0;
export const TYPE_AUDIO = 1;
export const TYPE_VIDEO = 2;


export const typeLabels = [
    'article', 
    'audio',
    'video'
];